import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CancelAssistantPlanMutation } from "../graphql/mutations";
import type {
  CancelAssistantPlanMutationType,
  CancelAssistantPlanMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCancelAssistantPlanMutation = (
  options?: MutationHookOptions<
    CancelAssistantPlanMutationType,
    CancelAssistantPlanMutationVariablesType
  >
) => {
  return useMutation<
    CancelAssistantPlanMutationType,
    CancelAssistantPlanMutationVariablesType
  >(CancelAssistantPlanMutation, options);
};
